import { create } from "zustand";
export const useCurrentPersonInfoStore = create((set) => ({
    personal: null,
    group: null,
    org: null,
    setPersonal: (personal) => set({ personal }),
    setGroup: (group) => set({ group }),
    setOrg: (org) => set({ org }),
}));
//# sourceMappingURL=current-person-store.js.map